import { isUUID } from 'shared/src/util/idTypeDetect'

export const useDeviceId = (): string | undefined => {
  const pathParts = window.location.pathname.split('/')
  if (pathParts.length > 1 && isUUID(pathParts[1])) {
    return pathParts[1]
  }
  return undefined
}
